function showWishlistToast(message) {
  var toast = document.querySelector('.wishlist-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<div class="wishlist-toast__content">' +
                      '<span class="wishlist-toast__icon">✓</span>' +
                      '<span class="wishlist-toast__message"></span>' +
                      '</div>';
    document.body.appendChild(toast);
  }
  
  var messageEl = toast.querySelector('.wishlist-toast__message');
  messageEl.textContent = message;
  
  if (toast.toastTimer) {
    clearTimeout(toast.toastTimer);
  }
  
  toast.classList.remove('removing');
  toast.classList.add('show');
  
  toast.toastTimer = setTimeout(function() {
    toast.classList.add('removing');
    setTimeout(function() {
      toast.classList.remove('show', 'removing');
    }, 300);
  }, 3000);
}

class WishlistManager {
  constructor() {
    this.apiUrl = window.themeVariables && window.themeVariables.wishlistApiUrl ? window.themeVariables.wishlistApiUrl : 'https://www.lonelyhub.cn/api';
    this.userId = null;
    this.deviceId = null;
    this.wishlistData = { productIds: [], counts: {} };
    this.init();
  }

  init() {
    const self = this;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        self.initializeUser();
      });
    } else {
      self.initializeUser();
    }
  }

  initializeUser() {
    this.userId = this.getShopifyCustomerId();
    this.deviceId = this.getOrCreateDeviceId();
    
    if (this.userId && this.deviceId) {
      this.mergeDeviceData();
    }
    
    this.loadWishlistFromServer();
    this.attachEventListeners();
  }

  getShopifyCustomerId() {
    if (window.themeVariables && window.themeVariables.customer && window.themeVariables.customer.id) {
      return String(window.themeVariables.customer.id);
    }
    return null;
  }

  getOrCreateDeviceId() {
    var deviceId = this.getCookie('device_id');
    if (!deviceId) {
      deviceId = this.generateUUID();
      this.setCookie('device_id', deviceId, 365);
    }
    return deviceId;
  }

  generateUUID() {
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  loadWishlistFromServer() {
    var self = this;
    var url = this.apiUrl + '/wishlist?';
    if (this.userId) {
      url += 'user_id=' + encodeURIComponent(this.userId);
    } else {
      url += 'device_id=' + encodeURIComponent(this.deviceId);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var data = JSON.parse(xhr.responseText);
          self.wishlistData = data;
          self.updateAllButtons();
          self.updateAllCounts();
          self.initAllProducts();
          
          // Load product stats from API (total counts for all products)
          self.loadProductStats();
          
          // Update header wishlist count
          self.updateHeaderWishlistCount();
        } catch (e) {
          console.error('Failed to parse wishlist data:', e);
        }
      }
    };
    xhr.onerror = function() {
      console.error('Failed to load wishlist from server');
    };
    xhr.send();
  }

  mergeDeviceData() {
    var self = this;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', this.apiUrl + '/user/merge', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        self.loadWishlistFromServer();
      }
    };
    xhr.send(JSON.stringify({
      user_id: this.userId,
      device_id: this.deviceId
    }));
  }

  toggleWishlist(productId, callback) {
    var self = this;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', this.apiUrl + '/wishlist/toggle', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var response = JSON.parse(xhr.responseText);
          
          if (response.is_active && response.count > 0) {
            if (self.wishlistData.productIds.indexOf(productId) === -1) {
              self.wishlistData.productIds.push(productId);
            }
          } else {
            var idx = self.wishlistData.productIds.indexOf(productId);
            if (idx > -1) {
              self.wishlistData.productIds.splice(idx, 1);
            }
          }
          
          if (response.count > 0) {
            self.wishlistData.counts[productId] = response.count;
          } else {
            delete self.wishlistData.counts[productId];
          }
          
          self.updateTotalCount(productId, response.total_count);
          self.updateButton(productId);
          self.updateCountDisplay(productId);
          
          var translations = window.wishlistTranslations || { added: 'Product added to Wishlist', removed: 'Product removed from wishlist' };
          var message = response.is_active ? translations.added : translations.removed;
          showWishlistToast(message);
          
          if (callback) {
            callback(response);
          }
        } catch (e) {
          console.error('Failed to parse toggle response:', e);
        }
      }
    };
    
    xhr.onerror = function() {
      console.error('Failed to toggle wishlist');
    };
    
    // Get product handle from multiple sources
    var productHandle = null;
    
    // Try 1: Get from wishlist wrapper data attribute
    var wrapper = document.querySelector('.product-item__wishlist-wrapper[data-product-id="' + productId + '"]');
    if (wrapper) {
      productHandle = wrapper.getAttribute('data-product-handle');
    }
    
    // Try 2: Get from product card
    if (!productHandle && wrapper) {
      var productCard = wrapper.closest('product-item') || wrapper.closest('[data-product-handle]');
      if (productCard) {
        productHandle = productCard.getAttribute('data-product-handle');
      }
    }
    
    // Try 3: Get from product link URL
    if (!productHandle && wrapper) {
      var productItem = wrapper.closest('.product-item');
      if (productItem) {
        var productLink = productItem.querySelector('a[href*="/products/"]');
        if (productLink) {
          var href = productLink.getAttribute('href');
          var match = href.match(/\/products\/([^/?#]+)/);
          if (match) {
            productHandle = match[1];
          }
        }
      }
    }
    
    console.log('Extracted product handle for ID', productId, ':', productHandle);
    
    var payload = { 
      product_id: productId,
      product_handle: productHandle
    };
    if (self.userId) {
      payload.user_id = self.userId;
    } else {
      payload.device_id = self.deviceId;
    }
    
    console.log('Toggling wishlist with payload:', payload);
    xhr.send(JSON.stringify(payload));
  }

  isInWishlist(productId) {
    return this.wishlistData.productIds.indexOf(productId) > -1;
  }

  getProductCount(productId) {
    return this.wishlistData.counts[productId] || 0;
  }

  updateButton(productId) {
    var wrappers = document.querySelectorAll('.product-item__wishlist-wrapper[data-product-id="' + productId + '"]');
    var isInWishlist = this.isInWishlist(productId);
    
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      if (!wrapper.classList) continue;
      
      var totalCount = parseInt(wrapper.getAttribute('data-total-count') || '0', 10);
      
      if (totalCount > 0) {
        wrapper.classList.add('has-count');
        if (isInWishlist) {
          wrapper.classList.add('is-active');
        } else {
          wrapper.classList.remove('is-active');
        }
      } else {
        wrapper.classList.remove('has-count');
        if (isInWishlist) {
          wrapper.classList.add('is-active');
        } else {
          wrapper.classList.remove('is-active');
        }
      }
    }
  }

  updateCountDisplay(productId) {
    var wrappers = document.querySelectorAll('.product-item__wishlist-wrapper[data-product-id="' + productId + '"]');
    
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var countElement = wrapper.querySelector('.product-item__wishlist-count');
      var totalCount = parseInt(wrapper.getAttribute('data-total-count') || '0', 10);
      
      if (countElement) {
        if (totalCount > 0) {
          countElement.textContent = '(' + totalCount + ')';
          if (wrapper.classList) {
            wrapper.classList.add('has-count');
          }
        } else {
          countElement.textContent = '';
          if (wrapper.classList) {
            wrapper.classList.remove('has-count');
          }
        }
      }
    }
  }

  updateTotalCount(productId, totalCount) {
    var wrappers = document.querySelectorAll('.product-item__wishlist-wrapper[data-product-id="' + productId + '"]');
    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i].setAttribute('data-total-count', totalCount || 0);
    }
  }

  updateAllButtons() {
    var productIds = this.wishlistData.productIds;
    for (var i = 0; i < productIds.length; i++) {
      this.updateButton(productIds[i]);
    }
  }

  updateAllCounts() {
    var counts = this.wishlistData.counts;
    var keys = Object.keys(counts);
    for (var i = 0; i < keys.length; i++) {
      var productId = parseInt(keys[i]);
      if (!isNaN(productId)) {
        this.updateCountDisplay(productId);
      }
    }
  }

  initAllProducts() {
    var wrappers = document.querySelectorAll('.product-item__wishlist-wrapper[data-product-id]');
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var productId = parseInt(wrapper.getAttribute('data-product-id'));
      if (productId && !isNaN(productId)) {
        this.updateButton(productId);
        this.updateCountDisplay(productId);
      }
    }
  }

  loadProductStats() {
    var self = this;
    var wrappers = document.querySelectorAll('.product-item__wishlist-wrapper[data-product-id]');
    var productIds = [];
    
    for (var i = 0; i < wrappers.length; i++) {
      var productId = parseInt(wrappers[i].getAttribute('data-product-id'));
      if (productId && !isNaN(productId)) {
        productIds.push(productId);
      }
    }
    
    if (productIds.length === 0) {
      return;
    }
    
    productIds.forEach(function(productId) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', self.apiUrl + '/product/' + productId + '/stats', true);
      
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var stats = JSON.parse(xhr.responseText);
            self.updateProductTotalCount(productId, stats.total_count || 0);
          } catch (e) {
            console.error('Failed to parse product stats:', e);
          }
        }
      };
      
      xhr.onerror = function() {
        console.error('Failed to load product stats for:', productId);
      };
      
      xhr.send();
    });
  }

  updateProductTotalCount(productId, totalCount) {
    var wrappers = document.querySelectorAll('.product-item__wishlist-wrapper[data-product-id="' + productId + '"]');
    
    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i].setAttribute('data-total-count', totalCount || 0);
    }
    
    this.updateCountDisplay(productId);
  }

  updateHeaderWishlistCount() {
    var headerCount = document.getElementById('header-wishlist-count');
    if (!headerCount) return;
    
    var count = this.wishlistData.productIds.length;
    
    if (count > 0) {
      headerCount.textContent = count;
      headerCount.style.display = '';
    } else {
      headerCount.style.display = 'none';
    }
  }

  attachEventListeners() {
    var self = this;
    
    // Prevent duplicate event listeners
    if (this.eventListenerAttached) {
      return;
    }
    this.eventListenerAttached = true;
    
    // Listen for page visibility changes (user returns to tab/page)
    // This ensures buttons update when user navigates back from wishlist page
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        console.log('🔄 Page visible again, refreshing wishlist state...');
        self.loadWishlistFromServer();
      }
    });
    
    // Listen for pageshow event (iOS Safari back button)
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        console.log('🔄 Page restored from cache, refreshing wishlist state...');
        self.loadWishlistFromServer();
      }
    });
    
    document.addEventListener('click', function(e) {
      var target = e.target;
      var wrapper = null;
      
      while (target && target !== document) {
        if (target.classList && target.classList.contains('product-item__wishlist-wrapper')) {
          wrapper = target;
          break;
        }
        target = target.parentElement;
      }
      
      if (wrapper) {
        e.preventDefault();
        e.stopPropagation();
        
        var productId = parseInt(wrapper.getAttribute('data-product-id'));
        if (!productId || isNaN(productId)) return;
        
        self.toggleWishlist(productId, function(response) {
          self.updateButton(productId);
          self.updateCountDisplay(productId);
          self.updateHeaderWishlistCount();
          
          // If on wishlist page and product was removed, animate it out
          if (self.isWishlistPage && !response.is_active) {
            self.removeFromWishlistPage(productId);
          } else if (wrapper.classList) {
            wrapper.classList.add('wishlist-animate');
            setTimeout(function() {
              wrapper.classList.remove('wishlist-animate');
            }, 300);
          }
        });
      }
    });
  }

  // Wishlist Page Methods
  initWishlistPage() {
    if (!document.getElementById('wishlist-grid')) return;
    
    this.currentPage = 1;
    this.itemsPerPage = 20;
    this.loadWishlistPage();
    this.attachWishlistPageListeners();
  }

  loadWishlistPage() {
    var self = this;
    var loadingEl = document.getElementById('wishlist-loading');
    var emptyEl = document.getElementById('wishlist-empty');
    var gridEl = document.getElementById('wishlist-grid');
    var container = document.getElementById('wishlist-products-container');
    var countEl = document.getElementById('wishlist-item-count');
    
    console.log('loadWishlistPage - Elements found:', {
      loading: !!loadingEl,
      empty: !!emptyEl,
      grid: !!gridEl,
      container: !!container,
      count: !!countEl
    });
    
    if (loadingEl) loadingEl.style.display = 'block';
    if (emptyEl) emptyEl.style.display = 'none';
    if (gridEl) gridEl.style.display = 'none';
    
    var url = this.apiUrl + '/wishlist?';
    if (this.userId) {
      url += 'user_id=' + encodeURIComponent(this.userId);
    } else {
      url += 'device_id=' + encodeURIComponent(this.deviceId);
    }
    
    console.log('Fetching wishlist from:', url);
    
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function() {
      console.log('Wishlist API response:', xhr.status, xhr.responseText);
      if (loadingEl) loadingEl.style.display = 'none';
      
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var data = JSON.parse(xhr.responseText);
          self.wishlistData = data;
          
          console.log('Wishlist data:', data);
          console.log('Product IDs:', data.productIds);
          
          if (data.productIds.length === 0) {
            if (emptyEl) emptyEl.style.display = 'block';
            if (countEl) countEl.textContent = '0';
            return;
          }
          
          if (countEl) countEl.textContent = data.productIds.length;
          if (gridEl) {
            gridEl.style.display = 'block';
            console.log('Showing grid, display:', gridEl.style.display);
          }
          
          console.log('Rendering products:', data.productIds.slice(0, self.itemsPerPage));
          self.renderWishlistProducts(data.productIds.slice(0, self.itemsPerPage));
          self.updateLoadMoreButton(data.productIds.length);
        } catch (e) {
          console.error('Failed to parse wishlist data:', e);
        }
      } else {
        console.error('API error:', xhr.status, xhr.responseText);
      }
    };
    xhr.onerror = function() {
      if (loadingEl) loadingEl.style.display = 'none';
      console.error('Failed to load wishlist - network error');
    };
    xhr.send();
  }

  renderWishlistProducts(productIds) {
    var container = document.getElementById('wishlist-products-container');
    if (!container) return;
    
    if (this.currentPage === 1) {
      container.innerHTML = '';
    }
    
    var self = this;
    console.log('=== renderWishlistProducts ===');
    console.log('Product IDs:', productIds);
    console.log('Handles data:', self.wishlistData.handles);
    
    productIds.forEach(function(productId) {
      var productHandle = self.wishlistData.handles && self.wishlistData.handles[productId];
      console.log('Rendering product ID:', productId, 'with handle:', productHandle);
      self.fetchAndRenderProduct(productId, productHandle, container);
    });
  }

  fetchAndRenderProduct(productId, productHandle, container) {
    var self = this;
    
    console.log('=== fetchAndRenderProduct START ===');
    console.log('Product ID:', productId, 'Handle:', productHandle);
    
    // First, get product stats
    var xhr = new XMLHttpRequest();
    xhr.open('GET', this.apiUrl + '/product/' + productId + '/stats', true);
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var stats = JSON.parse(xhr.responseText);
          console.log('Got stats for product:', productId, stats);
          
          // If we have a valid handle, use it directly (fastest method)
          if (productHandle && productHandle !== 'null' && productHandle !== null) {
            console.log('✅ Using handle to fetch product:', productHandle);
            var productXhr = new XMLHttpRequest();
            productXhr.open('GET', '/products/' + productHandle + '.js', true);
            productXhr.onload = function() {
              if (productXhr.status >= 200 && productXhr.status < 300) {
                try {
                  var product = JSON.parse(productXhr.responseText);
                  console.log('✅ Found product by handle:', product.id, product.title);
                  self.renderProductCard(product, container, stats);
                } catch (e) {
                  console.error('❌ Failed to parse product by handle:', e);
                  self.fetchProductByIdFallback(productId, container, stats);
                }
              } else {
                console.error('❌ Failed to fetch product by handle (HTTP ' + productXhr.status + ')');
                self.fetchProductByIdFallback(productId, container, stats);
              }
            };
            productXhr.onerror = function() {
              console.error('❌ Network error fetching product by handle');
              self.fetchProductByIdFallback(productId, container, stats);
            };
            productXhr.send();
          } else {
            // No handle available, use fallback method
            console.log('⚠️ No handle available, using fallback method for product:', productId);
            self.fetchProductByIdFallback(productId, container, stats);
          }
        } catch (e) {
          console.error('Failed to parse product stats:', productId, e);
        }
      } else {
        console.error('Failed to fetch product stats:', productId, xhr.status, xhr.responseText);
      }
    };
    xhr.onerror = function() {
      console.error('Network error fetching product stats:', productId);
    };
    xhr.send();
  }

  fetchProductByIdFallback(productId, container, stats) {
    var self = this;
    console.log('⚠️ Fallback: Fetching product ID', productId, 'from all products API...');
    
    // Try to fetch from /products.json with pagination
    var page = 1;
    var maxPages = 10; // Limit to prevent infinite loop
    
    function tryFetchPage(pageNum) {
      if (pageNum > maxPages) {
        console.error('❌ Product', productId, 'not found after checking', maxPages, 'pages');
        return;
      }
      
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/products.json?limit=250&page=' + pageNum, true);
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var response = JSON.parse(xhr.responseText);
            var products = response.products || [];
            
            console.log('📄 Page', pageNum, '- found', products.length, 'products');
            
            // Find product by ID (compare as numbers)
            for (var i = 0; i < products.length; i++) {
              var currentId = parseInt(products[i].id);
              var targetId = parseInt(productId);
              
              if (currentId === targetId) {
                console.log('✅ Found product on page', pageNum, ':', products[i].title, '(ID:', currentId, ')');
                self.renderProductCard(products[i], container, stats);
                return;
              }
            }
            
            // If not found and there are more products, try next page
            if (products.length === 250) {
              console.log('➡️ Product not found on page', pageNum, ', trying page', (pageNum + 1));
              tryFetchPage(pageNum + 1);
            } else {
              console.error('❌ Product', productId, 'not found in any page (checked', pageNum, 'pages total)');
            }
          } catch (e) {
            console.error('❌ Error parsing page', pageNum, ':', e);
          }
        } else {
          console.error('❌ HTTP error fetching page', pageNum, ':', xhr.status);
        }
      };
      xhr.onerror = function() {
        console.error('❌ Network error fetching page', pageNum);
      };
      xhr.send();
    }
    
    tryFetchPage(1);
  }

  renderProductCard(product, container, stats) {
    console.log('🎨 Rendering product card:', product.id, product.title);
    console.log('📦 Product data:', {
      id: product.id,
      title: product.title,
      handle: product.handle,
      images: product.images,
      image_count: product.images ? product.images.length : 0,
      first_image: product.images && product.images[0] ? product.images[0].src : 'NO IMAGE'
    });
    
    var productUrl = '/products/' + product.handle;
    
    // Get price from first variant
    // Shopify JSON APIs return price in CENTS as integer (e.g., 280 = $2.80)
    var variant = product.variants && product.variants[0];
    var priceInCents = variant ? parseInt(variant.price, 10) : 0;
    var compareAtPriceInCents = variant && variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0;
    
    var price = this.formatMoney(priceInCents);
    var comparePrice = compareAtPriceInCents > 0 ? this.formatMoney(compareAtPriceInCents) : '';
    
    var totalCount = stats && stats.total_count ? stats.total_count : 0;
    var isActive = this.wishlistData.productIds.indexOf(product.id) !== -1;
    
    // Build wishlist wrapper classes
    var wishlistClasses = 'product-item__wishlist-wrapper';
    if (isActive) {
      wishlistClasses += ' is-active';
    }
    if (totalCount > 0) {
      wishlistClasses += ' has-count';
    }
    
    // Build image HTML - use first image from images array
    var imageHtml = '';
    var aspectRatioStyle = '';
    
    if (product.images && product.images.length > 0) {
      // Images can be either a string array or object array
      var imgSrc = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
      
      // Ensure absolute URL (add https: if protocol-relative)
      if (imgSrc && imgSrc.indexOf('//') === 0) {
        imgSrc = 'https:' + imgSrc;
      }
      
      console.log('🖼️ Image URL:', imgSrc);
      
      // Get image dimensions for aspect ratio (use featured_media if available, otherwise default to 1:1)
      var imageWidth = 500;
      var imageHeight = 500;
      if (product.featured_media && product.featured_media.preview_image) {
        imageWidth = product.featured_media.preview_image.width || 500;
        imageHeight = product.featured_media.preview_image.height || 500;
      } else if (product.image && product.image.width) {
        imageWidth = product.image.width;
        imageHeight = product.image.height || imageWidth;
      }
      
      var aspectRatio = imageWidth / imageHeight;
      var paddingBottom = (100.0 / aspectRatio).toFixed(2);
      aspectRatioStyle = 'padding-bottom: ' + paddingBottom + '%; --aspect-ratio: ' + aspectRatio.toFixed(4);
      
      imageHtml = '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" class="product-item__primary-image">';
    } else {
      console.warn('⚠️ No images found for product:', product.id);
      // Default aspect ratio for empty state
      aspectRatioStyle = 'padding-bottom: 100%; --aspect-ratio: 1';
    }
    
    // Build price HTML
    var priceHtml = '';
    if (compareAtPriceInCents > priceInCents) {
      priceHtml = '<span class="price price--highlight">' + price + '</span>' +
                  '<span class="price price--compare">' + comparePrice + '</span>';
    } else {
      priceHtml = '<span class="price">' + price + '</span>';
    }
    
    // Build sold out label if needed
    var soldOutLabel = product.available ? '' : '<span class="label label--subdued">Sold out</span>';
    
    // Create product item HTML (matching product-item.liquid structure)
    var productItemHtml = 
      '<product-item class="product-item' + (product.available ? '' : ' product-item--sold-out') + '" data-product-handle="' + (product.handle || '') + '">' +
        '<div class="product-item__image-wrapper">' +
          (soldOutLabel ? '<div class="product-item__label-list label-list">' + soldOutLabel + '</div>' : '') +
          '<div class="' + wishlistClasses + '" data-product-id="' + product.id + '" data-total-count="' + totalCount + '" data-product-handle="' + (product.handle || '') + '">' +
            '<svg class="wishlist-icon wishlist-icon--outline' + (isActive ? '' : ' active') + '" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--wishlist-outline-color)" stroke-width="1.5">' +
              '<path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>' +
            '</svg>' +
            '<svg class="wishlist-icon wishlist-icon--filled' + (isActive ? ' active' : '') + '" width="22" height="22" viewBox="0 0 24 24" fill="var(--wishlist-filled-color)">' +
              '<path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>' +
            '</svg>' +
            '<span class="product-item__wishlist-count">' + (totalCount > 0 ? '(' + totalCount + ')' : '') + '</span>' +
          '</div>' +
          '<a href="' + productUrl + '" class="product-item__aspect-ratio aspect-ratio" style="' + aspectRatioStyle + '">' +
            imageHtml +
          '</a>' +
        '</div>' +
        '<div class="product-item__info">' +
          '<div class="product-item-meta">' +
            '<a href="' + productUrl + '" class="product-item-meta__title">' + (product.title || 'Product') + '</a>' +
            '<div class="price-list">' + priceHtml + '</div>' +
          '</div>' +
        '</div>' +
      '</product-item>';
    
    container.insertAdjacentHTML('beforeend', productItemHtml);
    console.log('✅ Product card rendered:', product.id, product.title);
  }

  formatMoney(cents) {
    // Use Shopify's money format from theme settings for multi-currency support
    var format = window.themeVariables && window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : (window.themeVariables && window.themeVariables.settings.moneyFormat);
    
    // Fallback to simple USD format if theme variables not available
    if (!format) {
      format = '${{amount}}';
    }
    
    // Convert cents to dollars with 2 decimal places
    var amount = (cents / 100).toFixed(2);
    
    // Replace placeholders in format string
    // {{amount}} = amount with decimals (e.g., "2.80")
    // {{amount_no_decimals}} = amount without decimals (e.g., "3")
    var formattedPrice = format.replace('{{amount}}', amount);
    formattedPrice = formattedPrice.replace('{{amount_no_decimals}}', Math.round(cents / 100).toString());
    
    return formattedPrice;
  }

  updateLoadMoreButton(totalItems) {
    var paginationEl = document.getElementById('wishlist-pagination');
    var loadMoreBtn = document.getElementById('load-more-btn');
    
    if (!paginationEl || !loadMoreBtn) return;
    
    var displayedItems = this.currentPage * this.itemsPerPage;
    
    if (displayedItems < totalItems) {
      paginationEl.style.display = 'block';
    } else {
      paginationEl.style.display = 'none';
    }
  }

  attachWishlistPageListeners() {
    var self = this;
    
    // Load More button
    var loadMoreBtn = document.getElementById('load-more-btn');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function() {
        self.currentPage++;
        var start = (self.currentPage - 1) * self.itemsPerPage;
        var end = start + self.itemsPerPage;
        var productIds = self.wishlistData.productIds.slice(start, end);
        self.renderWishlistProducts(productIds);
        self.updateLoadMoreButton(self.wishlistData.productIds.length);
      });
    }
    
    // Note: Wishlist toggle is handled by the global event listener in attachEventListeners()
    // When a product is removed from wishlist on this page, we need to handle it specially
    this.isWishlistPage = true;
  }

  removeFromWishlistPage(productId) {
    var self = this;
    
    // Update button state on all pages (not just wishlist page)
    // This ensures when user goes back, the button shows correct state
    self.updateButton(productId);
    self.updateCountDisplay(productId);
    
    // Find the product-item element on wishlist page
    var productItem = document.querySelector('.product-item__wishlist-wrapper[data-product-id="' + productId + '"]');
    if (productItem) {
      var item = productItem.closest('product-item');
      if (item) {
        item.style.opacity = '0';
        item.style.transition = 'opacity 0.3s';
        setTimeout(function() {
          item.remove();
          
          // Update count
          var countEl = document.getElementById('wishlist-item-count');
          if (countEl) {
            var currentCount = parseInt(countEl.textContent) - 1;
            countEl.textContent = currentCount;
            
            // Show empty state if no items
            if (currentCount === 0) {
              document.getElementById('wishlist-grid').style.display = 'none';
              document.getElementById('wishlist-empty').style.display = 'block';
            }
          }
        }, 300);
      }
    }
  }
}

// Singleton pattern to prevent duplicate instances
if (!window.wishlistManager) {
  window.wishlistManager = new WishlistManager();
}
